export class OrganizationCourseListModel {
	public version_id: string;
	public title: string;
	public course_number: string;
	public credits: number;
	public sced_code: string;
}
